/* bxgy-picker.js — Kaching-style tiered bundle selector (1 piece · optional mid tier · buy2get2 set · buy4get4 double).
   The selected tier card expands into one row per piece (thumbnail + a <select> per option). Rows default to the
   first available variant. Total = paid pieces; the cheapest pieces in the set are free (mirrors Shopify BXGY).
   EXTRAS (data.extras, up to 2 add-on products): an "add extras" strip under the tiers. Each tap appends one
   full-price row with its own option selects + remove. Extras live outside the Glow collections, so they are
   never free and never count toward the free sets — priced at face value here, exactly like checkout.
   Add = ONE POST to /cart/add.js with items[] grouped by variant (tier picks + extras), then cart:build + cart:open.
   No _bundleType properties: the drawer's own buy-2-get-2 bar must keep working. */
(function () {
  'use strict';
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = /no_decimals/.test(fmt) ? whole : (whole + '.' + parts[1]);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shortVal(val) { return val.replace(/^18k\s+Yellow\s+Gold$/i, 'Gold').replace(/^18k\s+/i, ''); }
  function plural(n, one, many) { return n === 1 ? one : many; }
  var HEART = {
    outline: '<svg class="bxgy__glyph" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10A4.2 4.2 0 0 1 12 8.2a4.2 4.2 0 0 1 7.5 2.3c0 5.4-7.5 10-7.5 10z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    solid: '<svg class="bxgy__glyph bxgy__glyph--small" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10A4.2 4.2 0 0 1 12 8.2a4.2 4.2 0 0 1 7.5 2.3c0 5.4-7.5 10-7.5 10z" fill="currentColor"/></svg>'
  };

  function init(root) {
    if (root.__bxgy) return; root.__bxgy = true;
    var data = JSON.parse(root.querySelector('[data-bxgy-data]').textContent);
    var OPTS = data.options, VARS = data.variants, byId = {};
    VARS.forEach(function (v) { byId[String(v.id)] = v; });
    var avail = VARS.filter(function (v) { return v.available; });
    if (!avail.length) avail = VARS.slice();
    var FIRST = avail[0];
    // extras: add-on products (each with its own options/variants); state.extras = [{ex: index, id: variantId}]
    var EXTRAS = (data.extras || []).map(function (ex) {
      var vs = ex.variants || [], av = vs.filter(function (v) { return v.available; });
      if (!av.length) av = vs.slice();
      var map = {}; vs.forEach(function (v) { map[String(v.id)] = v; });
      return { label: ex.label, short: ex.short, perSet: +ex.perSet || 0, glyph: ex.glyph, options: ex.options || [], variants: vs, avail: av, byId: map, first: av[0] };
    }).filter(function (ex) { return ex.first; });
    var UNIT = root.dataset.unit || 'piece', UNITS = root.dataset.units || 'pieces', NOUN = root.dataset.noun || '';
    // data-spread="1": empty slots pre-fill with one of EACH variant in catalog order (necklace gold, necklace silver,
    // earrings gold, …) instead of repeating the first variant — so a 4-piece set opens as the full assortment.
    var SPREAD = root.dataset.spread === '1';
    // Swatch mode: block setting names one option (e.g. Stone) + "value:hex" pairs; that option renders as gem dots instead of a <select>.
    var SW_OPT = (root.dataset.swatchOption || '').trim().toLowerCase(), SW_MAP = {};
    (root.dataset.swatchColors || '').split(',').forEach(function (p) { var i = p.indexOf(':'); if (i > 0) SW_MAP[p.slice(0, i).trim().toLowerCase()] = p.slice(i + 1).trim(); });
    function swBg(c) {
      var m = /^#?([0-9a-f]{6})$/i.exec(c); if (!m) return c;
      var n = parseInt(m[1], 16), r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
      function mix(t, k) { return 'rgb(' + [r, g, b].map(function (x) { return Math.round(x + (t - x) * k); }).join(',') + ')'; }
      return 'radial-gradient(circle at 35% 35%, ' + mix(255, .6) + ' 0%, rgb(' + r + ',' + g + ',' + b + ') 55%, ' + mix(0, .4) + ' 100%)';
    }
    // data-spread-order: optional comma-separated variant titles ("Earrings / 18k Yellow Gold, Necklace / Silver")
    // giving the fill order; unknown titles are skipped, missing ones fall back to catalog order.
    var SPREAD_LIST = (function () {
      var want = (root.dataset.spreadOrder || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var picked = want.map(function (t) {
        return avail.filter(function (v) { return v.options.join(' / ').toLowerCase() === t; })[0];
      }).filter(Boolean);
      return picked.length ? picked : avail;
    })();
    function defaultPick(slot) { return String((SPREAD ? SPREAD_LIST[slot % SPREAD_LIST.length] : FIRST).id); }
    // Optional per-variant detail crops shipped as theme assets: assets/bxgy-thumb-<variantId>.png
    // (made by the intake pipeline's pendant_crops.py). Probe each once; fall back to the variant image + CSS zoom.
    var thumbs = {};
    if (data.thumbBase) {
      VARS.forEach(function (v) {
        // per-variant versioned URL from Liquid (cache-safe); fall back to deriving it from the base
        var url = v.thumb || data.thumbBase.replace(/bxgy-thumb-0\.png(\?.*)?$/, 'bxgy-thumb-' + v.id + '.png');
        var probe = new Image();
        probe.onload = function () { thumbs[String(v.id)] = url; if (root.__bxgyRender) root.__bxgyRender(); };
        probe.src = url;
      });
    }
    var storeKey = 'bxgy4-' + root.dataset.productId;
    var tierEls = Array.prototype.slice.call(root.querySelectorAll('[data-bxgy-tier]'));
    var tiers = {}; tierEls.forEach(function (el) { tiers[el.dataset.bxgyTier] = { el: el, size: +el.dataset.size, free: +el.dataset.free, rows: el.querySelector('[data-bxgy-rows]') }; });
    var q = function (s) { return root.querySelector(s); };
    var wasEl = q('[data-bxgy-was]'), payEl = q('[data-bxgy-pay]'), savEl = q('[data-bxgy-saving]');
    var btn = q('[data-bxgy-submit]'), btnText = q('[data-bxgy-btn-text]'), err = q('[data-bxgy-err]');
    var sumEl = q('[data-bxgy-summary]'), nudgeEl = q('[data-bxgy-nudge]');
    var exRows = q('[data-bxgy-extra-rows]'), exAdd = q('[data-bxgy-extra-add]');
    var sticky = q('[data-bxgy-sticky]'), stCount = q('[data-bxgy-sticky-count]'), stPay = q('[data-bxgy-sticky-pay]'), stBtn = q('[data-bxgy-sticky-btn]');
    var stWas = q('[data-bxgy-sticky-was]'), stBtnPrice = q('[data-bxgy-sticky-btn-price]'), stThumb = q('[data-bxgy-sticky-thumb]');

    // state: tier + picks per tier (variant id per slot), so switching tiers keeps what was chosen; extras persist across tiers
    var state = { tier: null, picks: {}, extras: [] };
    try { var s = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); if (s && tiers[s.tier]) { state = s; } } catch (e) {}
    if (!state.tier || !tiers[state.tier]) { var d = root.dataset.defaultTier; state.tier = tiers[d] ? d : (tiers.set ? 'set' : Object.keys(tiers)[0]); }
    state.picks = state.picks || {}; state.extras = (state.extras || []).filter(function (x) { return EXTRAS[x.ex] && EXTRAS[x.ex].byId[x.id]; });
    Object.keys(tiers).forEach(function (k) {
      var N = tiers[k].size, arr = (state.picks[k] || []).filter(function (id) { return byId[id]; }).slice(0, N);
      while (arr.length < N) arr.push(defaultPick(arr.length));
      state.picks[k] = arr;
    });

    // A new extra defaults to the colour of the first set in the chosen tier (a mom buying silver sets wants a silver
    // heart), matched by option NAME across the two products; falls back to the add-on's first available variant.
    function defaultExtraVariant(ex) {
      var setV = byId[(state.picks[state.tier] || [])[0]];
      if (setV) {
        for (var oi = 0; oi < ex.options.length; oi++) {
          var si = OPTS.findIndex(function (o) { return o.name === ex.options[oi].name; });
          if (si < 0) continue;
          var want = setV.options[si];
          var m = ex.avail.find(function (v) { return v.options[oi] === want; });
          if (m) return m;
        }
      }
      return ex.first;
    }
    function findVariant(list, options) {
      return list.find(function (v) { return v.options.every(function (o, i) { return o === options[i]; }); });
    }
    // after changing option index `ci` to `val`, keep other options if that combo exists, else first available with that value
    function resolve(list, availList, current, ci, val) {
      var want = current.options.slice(); want[ci] = val;
      var exact = findVariant(list, want);
      if (exact && exact.available) return exact;
      var alt = availList.find(function (v) { return v.options[ci] === val; });
      return alt || exact || current;
    }
    function units(picks, nFree) {
      var u = picks.map(function (id, i) { var v = byId[id]; return { id: id, i: i, v: v, price: v.price, compare: v.compare || 0, free: false }; });
      var sorted = u.slice().sort(function (a, b) { return a.price - b.price; });
      for (var k = 0; k < nFree && k < sorted.length; k++) sorted[k].free = true;
      return u;
    }
    function totalsFor(k) {
      var T = tiers[k], u = units(state.picks[k], T.free), pay = 0, was = 0;
      u.forEach(function (x) { was += (x.compare > x.price ? x.compare : x.price); if (!x.free) pay += x.price; });
      return { pay: pay, was: was, units: u };
    }
    function extrasTotals() {
      var pay = 0, was = 0;
      state.extras.forEach(function (x) { var v = EXTRAS[x.ex].byId[x.id]; pay += v.price; was += (v.compare > v.price ? v.compare : v.price); });
      return { pay: pay, was: was, n: state.extras.length };
    }

    function selectsHtml(opts, list, availList, v, attr) {
      return opts.map(function (o, oi) {
        // Later options are filtered by the earlier selections on this row (Shopify-style): e.g. with Silver
        // chosen, only styles that exist in Silver are listed — a gold-only style never appears in the dropdown.
        var values = o.values.filter(function (val) {
          return availList.some(function (av) {
            if (av.options[oi] !== val) return false;
            for (var j = 0; j < oi; j++) if (av.options[j] !== v.options[j]) return false;
            return true;
          });
        });
        if (SW_OPT && o.name.toLowerCase() === SW_OPT && values.some(function (val) { return SW_MAP[val.toLowerCase()]; })) {
          return '<div class="bxgy__swatches" ' + attr + '="' + oi + '" role="radiogroup" aria-label="' + esc(o.name) + '">' + values.map(function (val) {
            var on = val === v.options[oi];
            return '<button type="button" class="bxgy__swatch' + (on ? ' is-on' : '') + '" data-bxgy-swatch="' + esc(val) + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" aria-label="' + esc(val) + '" title="' + esc(val) + '" style="--sw:' + swBg(SW_MAP[val.toLowerCase()] || '#cccccc') + '"></button>';
          }).join('') + '<span class="bxgy__swatch-name">' + esc(shortVal(v.options[oi])) + '</span></div>';
        }
        return '<select class="bxgy__select" ' + attr + '="' + oi + '" aria-label="' + esc(o.name) + '">' + values.map(function (val) {
          return '<option value="' + esc(val) + '"' + (val === v.options[oi] ? ' selected' : '') + '>' + esc(shortVal(val)) + '</option>';
        }).join('') + '</select>';
      }).join('');
    }
    function thumbAttr(v, cropUrl) {
      return cropUrl
        ? 'class="bxgy__row-img bxgy__row-img--crop" style="background-image:url(&quot;' + esc(cropUrl) + '&quot;)"'
        : 'class="bxgy__row-img" style="background-image:url(&quot;' + esc(v.image) + '&quot;)"';
    }
    function rowHtml(k, i, x, N) {
      var v = x.v, sels = selectsHtml(OPTS, VARS, avail, v, 'data-bxgy-opt');
      var tag = x.free
        ? '<span class="bxgy__row-price"><s>' + money(v.price) + '</s> <em class="bxgy__row-free">FREE</em></span>'
        : '<span class="bxgy__row-price">' + money(v.price) + '</span>';
      var label = N === 1 ? 'Your ' + UNIT : UNIT.charAt(0).toUpperCase() + UNIT.slice(1) + ' ' + (i + 1);
      return '<div class="bxgy__row' + (x.free ? ' is-free' : '') + '" data-bxgy-row="' + i + '" style="--i:' + i + '">'
        + '<button type="button" class="bxgy__row-zoom" data-bxgy-zoom="' + v.id + '" aria-label="View ' + esc(v.options.join(' / ')) + ' full size">'
        + '<span ' + thumbAttr(v, thumbs[String(v.id)]) + ' role="img" aria-label="' + esc(v.options.join(' / ')) + '"></span><span class="bxgy__row-plus" aria-hidden="true">+</span></button>'
        + '<div class="bxgy__row-main"><div class="bxgy__row-top"><span class="bxgy__row-label">' + esc(label) + '</span>' + tag + '</div>'
        + '<div class="bxgy__row-selects">' + sels + '</div></div></div>';
    }
    function extraRowHtml(x, i) {
      var ex = EXTRAS[x.ex], v = ex.byId[x.id];
      var sels = selectsHtml(ex.options, ex.variants, ex.avail, v, 'data-bxgy-xopt');
      // the add-on's own variant image IS the detail crop (uploaded that way), so render it edge-to-edge
      return '<div class="bxgy__row bxgy__row--extra" data-bxgy-xrow="' + i + '" style="--i:' + i + '">'
        + '<button type="button" class="bxgy__row-zoom" data-bxgy-xzoom="' + i + '" aria-label="View ' + esc(ex.label) + ' full size">'
        + '<span ' + thumbAttr(v, v.image) + ' role="img" aria-label="' + esc(ex.label) + '"></span><span class="bxgy__row-plus" aria-hidden="true">+</span></button>'
        + '<div class="bxgy__row-main"><div class="bxgy__row-top"><span class="bxgy__row-label">Extra · ' + esc(ex.short) + '</span>'
        + '<span class="bxgy__row-price">' + money(v.price)
        + ' <button type="button" class="bxgy__row-remove" data-bxgy-xremove="' + i + '" aria-label="Remove this ' + esc(ex.label.toLowerCase()) + '">Remove</button></span></div>'
        + '<div class="bxgy__row-selects">' + sels + '</div></div></div>';
    }
    function addButtonsHtml() {
      return EXTRAS.map(function (ex, i) {
        var g = HEART[ex.glyph] || '';
        return '<button type="button" class="bxgy__extra-btn" data-bxgy-xadd="' + i + '">' + g + '<span>+ ' + esc(ex.label) + '</span><em>' + money(ex.first.price) + '</em></button>';
      }).join('');
    }
    // "8 hearts · 4 big · 4 small": per-set composition × sets + the extras of each kind
    function summaryText(size) {
      if (!EXTRAS.length || !EXTRAS.some(function (ex) { return ex.perSet > 0; })) return '';
      var total = 0, parts = EXTRAS.map(function (ex, i) {
        var n = ex.perSet * size + state.extras.filter(function (x) { return x.ex === i; }).length; total += n;
        return n + ' ' + ex.short;
      });
      return total + (NOUN ? ' ' + NOUN : '') + ' · ' + parts.join(' · ');
    }
    // a bigger tier that costs no more than the current tier + extras → offer the upgrade (one tap, extras kept)
    function nudgeFor(k, totalPay) {
      var cur = tiers[k], best = null;
      Object.keys(tiers).forEach(function (j) {
        var T = tiers[j]; if (T.size <= cur.size) return;
        var p = totalsFor(j).pay; if (p > totalPay) return;
        if (!best || T.size > best.T.size) best = { k: j, T: T, pay: p };
      });
      return best;
    }

    function render() {
      var active = tiers[state.tier];
      tierEls.forEach(function (el) {
        var k = el.dataset.bxgyTier, T = tiers[k], on = k === state.tier;
        el.classList.toggle('is-active', on);
        var r = el.querySelector('input'); if (r) r.checked = on;
        var p = el.querySelector('[data-bxgy-tier-price]'), w = el.querySelector('[data-bxgy-tier-was]');
        var t = totalsFor(k);
        p.textContent = money(t.pay);
        w.textContent = t.was > t.pay ? money(t.was) : '';
        T.rows.hidden = !on;
        if (on) {
          var tierChanged = T.rows.dataset.shown !== '1';
          T.rows.innerHTML = t.units.map(function (x, i) { return rowHtml(k, i, x, T.size); }).join('');
          T.rows.classList.toggle('is-animate', tierChanged); T.rows.dataset.shown = '1';   // stagger only when the card opens, not on every dropdown change
        } else { T.rows.dataset.shown = ''; }
      });
      if (exRows) {
        exRows.innerHTML = state.extras.map(extraRowHtml).join('');
        exRows.hidden = !state.extras.length;
        if (!exAdd.dataset.ready) { exAdd.innerHTML = addButtonsHtml(); exAdd.dataset.ready = '1'; }
      }
      var t = totalsFor(state.tier), N = active.size, x = extrasTotals();
      var pay = t.pay + x.pay, was = t.was + x.was;
      payEl.textContent = money(pay); wasEl.textContent = was > pay ? money(was) : '';
      savEl.textContent = was > pay ? '· you save ' + money(was - pay) : '';
      if (sumEl) { var st = summaryText(N), cnt = (N === 1 && !x.n) ? '' : (N + ' ' + plural(N, UNIT, UNITS) + (x.n ? ' + ' + x.n + ' ' + plural(x.n, 'extra', 'extras') : '')); sumEl.textContent = cnt && st ? cnt + ' · ' + st : (cnt || st); sumEl.hidden = !(cnt || st); }
      if (nudgeEl) {
        var ng = x.n ? nudgeFor(state.tier, pay) : null;
        if (ng) {
          var diff = pay - ng.pay;
          nudgeEl.innerHTML = (diff > 0 ? 'Save ' + money(diff) + ': ' : 'Same price: ') + '<strong>' + ng.T.size + ' ' + esc(UNITS) + '</strong> is ' + money(ng.pay) + (ng.T.free ? ' (' + ng.T.free + ' free)' : '') + ' — switch';
          nudgeEl.dataset.tier = ng.k; nudgeEl.hidden = false;
        } else nudgeEl.hidden = true;
      }
      btn.disabled = false;
      btnText.textContent = 'Add to cart — ' + money(pay);
      stCount.textContent = (N === 1 ? '1 ' + UNIT : N + ' ' + UNITS + ' · ' + active.free + ' free') + (x.n ? ' + ' + x.n + ' ' + plural(x.n, 'extra', 'extras') : '');
      stPay.textContent = money(pay); stBtn.disabled = false;
      if (stWas) stWas.textContent = was > pay ? money(was) : '';
      if (stBtnPrice) stBtnPrice.textContent = money(pay);
      if (stThumb) { var fv = byId[state.picks[state.tier][0]]; if (fv) stThumb.style.backgroundImage = 'url("' + (thumbs[String(fv.id)] || fv.image) + '")'; }
      updateSticky();
      try { sessionStorage.setItem(storeKey, JSON.stringify(state)); } catch (e) {}
    }

    root.__bxgyRender = render;
    // Same reveal rule as the theme's own sticky bar: only once the main button has scrolled UP out of view
    // (not while it's still below the fold on first load). Any width — the theme shows its bar on desktop too.
    var ticking = false;
    function updateSticky() { var show = btn.getBoundingClientRect().bottom <= 0; sticky.hidden = !show; sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); }
    // plain timer throttle (not rAF: rAF never fires in a backgrounded tab, which left the bar stuck hidden)
    function onScroll() { if (!ticking) { ticking = true; setTimeout(function () { ticking = false; updateSticky(); }, 60); } }
    window.addEventListener('scroll', onScroll, { passive: true });

    root.addEventListener('change', function (e) {
      var xsel = e.target.closest('[data-bxgy-xopt]');
      if (xsel) {   // an extra row's option changed
        var xrow = xsel.closest('[data-bxgy-xrow]'), xi = +xrow.dataset.bxgyXrow, st = state.extras[xi], ex = EXTRAS[st.ex];
        var nx = resolve(ex.variants, ex.avail, ex.byId[st.id], +xsel.dataset.bxgyXopt, xsel.value);
        st.id = String(nx.id); render(); return;
      }
      var tEl = e.target.closest('[data-bxgy-tier]');
      if (!tEl) return;
      if (e.target.type === 'radio') { state.tier = tEl.dataset.bxgyTier; render(); return; }
      var sel = e.target.closest('[data-bxgy-opt]'); if (!sel) return;
      var row = sel.closest('[data-bxgy-row]'), i = +row.dataset.bxgyRow, k = tEl.dataset.bxgyTier;
      var cur = byId[state.picks[k][i]], nv = resolve(VARS, avail, cur, +sel.dataset.bxgyOpt, sel.value);
      state.picks[k][i] = String(nv.id); render();
      root.dispatchEvent(new CustomEvent('bxgy:pick', { detail: { slot: i, variantId: nv.id, image: nv.image } }));
    });
    // lightbox: tap a row thumbnail → full render
    var lb = q('[data-bxgy-lightbox]'), lbImg = q('[data-bxgy-lb-img]'), lbCap = q('[data-bxgy-lb-cap]');
    function openLb(v, cap) {
      lbImg.src = v.large || v.image; lbImg.alt = cap; lbCap.textContent = cap;
      lb.hidden = false; document.body.classList.add('bxgy-lb-open'); q('.bxgy-lb__close').focus();
    }
    function closeLb() { if (lb.hidden) return; lb.hidden = true; document.body.classList.remove('bxgy-lb-open'); lbImg.removeAttribute('src'); }
    lb.addEventListener('click', function (e) { if (e.target.closest('[data-bxgy-lb-close]')) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    // clicking anywhere on a card's head selects it (the radio is visually hidden)
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-bxgy-swatch]');
      if (sw) { var grp = sw.closest('[data-bxgy-opt],[data-bxgy-xopt]'); if (grp) { grp.value = sw.dataset.bxgySwatch; grp.dispatchEvent(new Event('change', { bubbles: true })); } return; }
      var z = e.target.closest('[data-bxgy-zoom]'); if (z) { e.preventDefault(); var v = byId[z.dataset.bxgyZoom]; if (v) openLb(v, v.options.map(shortVal).join(' · ')); return; }
      var xz = e.target.closest('[data-bxgy-xzoom]'); if (xz) { e.preventDefault(); var sx = state.extras[+xz.dataset.bxgyXzoom]; if (sx) { var xv = EXTRAS[sx.ex].byId[sx.id]; openLb(xv, EXTRAS[sx.ex].label + ' · ' + xv.options.map(shortVal).join(' · ')); } return; }
      var xa = e.target.closest('[data-bxgy-xadd]'); if (xa) { var ex = EXTRAS[+xa.dataset.bxgyXadd]; if (ex && state.extras.length < 12) { state.extras.push({ ex: +xa.dataset.bxgyXadd, id: String(defaultExtraVariant(ex).id) }); render(); } return; }
      var xr = e.target.closest('[data-bxgy-xremove]'); if (xr) { state.extras.splice(+xr.dataset.bxgyXremove, 1); render(); return; }
      var ng = e.target.closest('[data-bxgy-nudge]'); if (ng && ng.dataset.tier && tiers[ng.dataset.tier]) { state.tier = ng.dataset.tier; render(); return; }
      var head = e.target.closest('.bxgy__tier-head'); if (!head) return;
      var tEl = head.closest('[data-bxgy-tier]'); if (tEl.dataset.bxgyTier !== state.tier) { state.tier = tEl.dataset.bxgyTier; render(); }
    });

    function submit() {
      var picks = state.picks[state.tier], grouped = {}, order = [];
      function add(id) { if (!grouped[id]) { grouped[id] = 0; order.push(id); } grouped[id]++; }
      picks.forEach(add);
      state.extras.forEach(function (x) { add(x.id); });
      var items = order.map(function (id) { return { id: Number(id), quantity: grouped[id] }; });
      err.hidden = true; btn.classList.add('is-loading'); stBtn.disabled = true;
      var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; })
        .then(function () { btn.classList.remove('is-loading'); stBtn.disabled = false; });
    }
    btn.addEventListener('click', submit);
    stBtn.addEventListener('click', submit);
    window.addEventListener('resize', updateSticky);
    render();
  }

  function boot() { document.querySelectorAll('[data-bxgy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
